import { render, staticRenderFns } from "./SendProjectDialog.vue?vue&type=template&id=0c2f7d89&scoped=true"
import script from "./SendProjectDialog.vue?vue&type=script&lang=js"
export * from "./SendProjectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2f7d89",
  null
  
)

export default component.exports